import React from 'react';
import { StarPicker } from 'react-star-picker';
import { StarPickerContainer } from './styles';
import Star from './StarImages/Star.svg';
import HalfStar from './StarImages/HalfStar.svg';

const StarRate = (props) => {
  if (typeof window === 'undefined') return <></>;
  return (
    <StarPickerContainer className="star-picker--container">
      <StarPicker
        size={40}
        disabled
        {...props}
        starRenderer={({ index }) => <img src={index == 4 ? HalfStar : Star} />}
      />
    </StarPickerContainer>
  );
};

export default StarRate;
